import script from "./UseScrollToTop.vue?vue&type=script&lang=js"
export * from "./UseScrollToTop.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__